import StarRating from '../UI/StarRating';
import './Reviews.css';

function SellerRating({ ratingSum, ratingCount }) {
  const count = Number(ratingCount) || 0;
  const sum = Number(ratingSum) || 0;
  const average = count > 0 ? Math.min(sum / count, 5).toFixed(1) : '0';

  return (
    <span
      className="sellerRatingWrap"
      title={`${average} out of 5 (${count} reviews)`}
    >
      <StarRating rating={Number(average)} size={14} />
      <span>
        {average} ({count})
      </span>
    </span>
  );
}

export default SellerRating;
